import type { FaireProductEntity } from "../../entity_types/product";

export const p_hfxz6w7aa7: FaireProductEntity = {
  token: "p_hfxz6w7aa7",
  type: "product",
  name: "Red Game Day Bracelets &  Necklaces",
  brandToken: "b_cyq0jgl0zz",
  brandName: "Savvy Bling",
  imageUrl:
    "https://cdn.faire.com/fastly/eb79089dce6b20058b54b5b8478b5fc0fe791d7cb7ca3608b723b44eeb994a06.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c5213c58c0706bed3fa8c0c0309b3a5dae40c3778056ccb3ae9e662de38bd923.jpeg",
    "https://cdn.faire.com/fastly/d1266280d13eccdfb11c6d0a47c191ba1bd7c175d44cc0d3932cb5f8b90ef341.jpeg",
    "https://cdn.faire.com/fastly/e084e3cb63c3adeb29b0fb52d4d2591a513a1339137cab6d9fd57072cc50e699.jpeg",
    "https://cdn.faire.com/fastly/30b1c0b8b732485334171fe9ab5867afa4579b933fcdefe49e05884be9195254.jpeg",
    "https://cdn.faire.com/fastly/40215565509b406e375c9da2ea4f4260881a495ca6c6e3bdbecc35d39eb9129b.jpeg",
    "https://cdn.faire.com/fastly/5db7df89ded1fa492bc85426c736c15ffb264a5a768b4f0748211e9194a0b1a6.jpeg",
    "https://cdn.faire.com/fastly/aedab82a79c77fafe4a5d4df86c7dddc5cb58dd0bdb8e776a90ff5c30bfb964f.jpeg",
    "https://cdn.faire.com/fastly/19d75bbeffe0da92551696da342eb98eb57e32898e00d0c1fb466b996bf4dfe2.jpeg",
    "https://cdn.faire.com/fastly/03fb20b1147920dfe4da56695b3df03534447b6b72fe924c1cc1b632c6fadd25.jpeg",
    "https://cdn.faire.com/fastly/62e54c98757c08e6084cd987039a815e82366fac0abb7ab3ada64767fcac1c23.jpeg",
    "https://cdn.faire.com/fastly/228d85030afd0aa9e3e699620f8f680bac39c21a111e991567b49be58fbafd23.jpeg",
    "https://cdn.faire.com/fastly/097c7f32568e7fe07b8252cd125040e8de5b091c669e7f519419dc3d67b6f6a6.jpeg",
    "https://cdn.faire.com/fastly/1858a0de674847bf0e1d99636fb9a65ee00b98b1338feb33b4259a8f799d003e.jpeg",
    "https://cdn.faire.com/fastly/20620839a934f82982526799dc518b5660d4ba12d6728720db6a917a0740b332.jpeg",
    "https://cdn.faire.com/fastly/af2fd7d687a87f60080841e2f3db51f48a325a2719b2ffe413066918e6b45df8.jpeg",
    "https://cdn.faire.com/fastly/8986b9e6a384997b85c742864226b253a665cc714532e8097d0ffac9c6b82549.jpeg",
    "https://cdn.faire.com/fastly/829527b1f5a1ebcbd0c0bb52b456591661fa9e921d463f5285f8cd9deb166d7f.jpeg",
    "https://cdn.faire.com/fastly/a1dd2ce27426a8150da78eeffeb99a9a34e5c21794deba9c760d8045c1334c94.jpeg",
    "https://cdn.faire.com/fastly/92d6f0cb7fd2f69eb9e1fb0de6c0a746603ac43bab0fe63760c2aa2f044b50a5.jpeg",
    "https://cdn.faire.com/fastly/9a41f6f4643b7c017ea2afc34100468f837b676f59c1508e17cf26463a08a7c7.jpeg",
    "https://cdn.faire.com/fastly/d48a35cb0db9c69dea2b7764c5c53152c04deec868306034ff3b3aa3b493a5e4.jpeg",
    "https://cdn.faire.com/fastly/bd51e7cf669603fcd8684e136d632cbaec22a65d73a1260984305eb920a1df9e.jpeg",
    "https://cdn.faire.com/fastly/6ee017bbb163a0e969e3cba0a241a51c99b8649d54698567361833f1501e97bd.jpeg",
    "https://cdn.faire.com/fastly/610100c5fa535a5ef828a3df84fcd711b1afec49f16d4a14dc80f4741ec965a3.jpeg",
    "https://cdn.faire.com/fastly/a96c46406014c0715f965da6671949978a9bb2b1b68fa9b2ebbfd52ba4da7f03.jpeg",
    "https://cdn.faire.com/fastly/09ea40bc2ccda98d2245216334215f48b594d3d114503b20f2fc97240a796213.jpeg",
    "https://cdn.faire.com/fastly/3278dd1b6302587cf3be32b2ffa905d9348d42d6c74e6ba303af56ff684d68a9.jpeg",
    "https://cdn.faire.com/fastly/d8393576d489033a854cfd677f975d849f61da9dc83af544272d4889bc1b01c0.jpeg",
    "https://cdn.faire.com/fastly/4d031d9997af209cfc2a9ebbc6799d400821a75690284293110d8397d22f4c3b.jpeg",
    "https://cdn.faire.com/fastly/38eb49a9b28682d755fbb38c62dd07665407900206932e1280d05f6fd0bf5c10.jpeg",
    "https://cdn.faire.com/fastly/aec77e9b9de5c26380ef73cad32f23d1d46c7f663c621d28b0e8e4fa6d39bdc7.jpeg",
    "https://cdn.faire.com/fastly/847eaf54449af6960cc76bea31d56f9c34c66710e4e37b6c8d4164b554a86352.jpeg",
    "https://cdn.faire.com/fastly/4b2a85e4d958c91fec264f6abc4c42c239e2d6f53c91bbeac64d69fd4818758d.jpeg",
    "https://cdn.faire.com/fastly/70ffbdbbad4194b295aa04f94858c4c62c0d9a9711bbbc415d35dfa9e021babf.jpeg",
    "https://cdn.faire.com/fastly/3ef4dc2962d5e0c680dbcabe8f2ed29c8eecb9d236ff1615d2c8f6cef10ef4cb.jpeg",
    "https://cdn.faire.com/fastly/0279d066c924cdb3f3165b7de18973feb6766a73a93ad4e455719b29b59e5e66.jpeg",
    "https://cdn.faire.com/fastly/8d6ef21a1164612c651c71a6d9490013f1f864d87737fb5aa761b12051d4ca14.jpeg",
    "https://cdn.faire.com/fastly/3355ea7e25aaacde91d6725f8d7bc68fd2905ac145ce230fc554f25fd9862d64.jpeg",
    "https://cdn.faire.com/fastly/e53461051a0718787d11dc0bb09296a642d09acd9fac1805438dacd34ef93ebb.jpeg",
    "https://cdn.faire.com/fastly/31475db4e1b0dc53370b73ea4b40effa05e836abd1ae4596f3c703f75d44dd59.jpeg",
    "https://cdn.faire.com/fastly/aa3c1e218ae97559b1930b1f8c12a1976b3e00e988857d48d9bb2c9b56ac1c18.jpeg",
    "https://cdn.faire.com/fastly/dfc31b8b4736f21b07b5be642f82d7df9829ca86c85ca6920a92cf71372293de.jpeg",
    "https://cdn.faire.com/fastly/8f7c269253149ed48ee25c1e2db3f0eecb78df1d25616f15b163d7956f615edf.jpeg",
  ],
  priceDollars: 11.09,
  description:
    "Support your team on game day with these durable and stylish game day bracelets. Perfect for showing team pride, each bracelet is made of quality, features a comfortable fit. Show your team spirit and stay in the game.",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:36.977Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
